// extracted by mini-css-extract-plugin
export default {"neg":"Positions_neg__w5z1O","negSign":"Positions_negSign__JCF+s","pos":"Positions_pos__4FdDR","posSign":"Positions_posSign__Og6SU"};